import React, {useEffect} from 'react';
import {Row} from "react-bootstrap";
import {Trash2} from "react-feather";
import NewAuftraggeber from "./NewAuftraggeber";
import {getToken} from "../../Utils/Common";

function Auftraggeber(props) {

    const [agData, setAGData] = React.useState(props.auftraggeberData);
    const [projectIDData, setprojectIDData] = React.useState([])

    useEffect(() => {
        setAGData(props.auftraggeberData);
        fetchAG().then(agData => {
            setprojectIDData(agData.data)
        })
    }, [agData]);

    async function fetchAG() {

        let apiBody = {
            "token": getToken(), "data": {
                "projectID": props.pID
            }
        }

        return await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/auftraggeberList", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    function getAuftraggeberTableBody(auftraggeberData) {
        return auftraggeberData?.map((item) => (<tr key={item.id}>
            <td>{item.firstName}</td>
            <td>{item.lastName}</td>
            <td
                style={{
                    display: props.originState ? "none" : "table-cell", textAlign: "center", verticalAlign: "middle",
                }}
            >
                <button
                    disabled={props.tstatus==="Akzeptiert"}
                    className="btn btn-danger"
                        onClick={() => deleteAuftraggeber(item)}
                >
                    <Trash2/>
                </button>
            </td>
        </tr>))
    }

    const deleteAuftraggeber = (itemtodel) => {
        props.setIsChange(false)
        let newAuftraggeberData = props.auftraggeberData.filter((item) => item !== itemtodel);
        setAGData(newAuftraggeberData);

        while (props.auftraggeberData.length > 0) {
            props.auftraggeberData.pop();
        }
        newAuftraggeberData.map((item) => {
            props.auftraggeberData.push(item);
        });
    }

    return (<>
        <NewAuftraggeber
            tstatus={props.tstatus}
            projectID={props.pID}
            originState={props.originState}
            auftraggeberReportData={props.auftraggeberData}
            setAuftraggeberReportData={setAGData}
            projectIDData={projectIDData}
            setIsChange={props.setIsChange}
        />
        <br/>
        <Row>
            <table className="table handwai-white-text">
                <thead>
                <tr>
                    <th scope="col">Vorname</th>
                    <th scope="col">Nachname</th>
                    <th scope="col" style={{display: props.originState ? "none" : "table-cell"}}>Löschen</th>
                </tr>
                </thead>
                <tbody>
                {getAuftraggeberTableBody(props.auftraggeberData)}
                </tbody>
            </table>
        </Row>
    </>);
}

export default Auftraggeber;
